export const codeFromKeyCode: Record<number, string> = {
  9: 'Tab',
  13: 'Enter',
  27: 'Escape',
  32: 'Space',
  33: 'PageUp',
  34: 'PageDown',
  35: 'End',
  36: 'Home',
  37: 'ArrowLeft',
  38: 'ArrowUp',
  39: 'ArrowRight',
  40: 'ArrowDown',
};

/**
 * Gets the `code` from a keyboard event.
 *
 * Some old browsers (on set-top boxes) don't have `KeyboardEvent.code`.
 * Modern browsers both have `KeyboardEvent.keyCode` and `KeyboardEvent.code`.
 * Events in tests (using testing-library/user-events) have a keyCode of `0`.
 * So we need to check both fields.
 */
export const getCodeFromEvent = (event: KeyboardEvent): string => {
  return event.code || codeFromKeyCode[event.keyCode] || 'unknown';
};

/**
 * Checks whether any of the modifier keys was pressed.
 */
export const isKeyCombination = (event: KeyboardEvent) => {
  return event.altKey || event.ctrlKey || event.shiftKey || event.metaKey;
};
